// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"29b4321a2ab2eb36","931":"6b44f5f32611addc"}[chunkId] + ".css";
};